/**
 * Shared validation helpers for API services
 * @module services/shared/validationHelpers
 */

/**
 * Validate ID parameter to prevent null/undefined requests
 * @param {string} id - The ID to validate
 * @param {string} resourceName - Name of the resource for error message
 * @returns {boolean} - true if valid, false if invalid
 */
export const isValidId = (id, resourceName = 'Resource') => {
  if (!id || id === 'null' || id === 'undefined' || id === 'NaN') {
    console.warn(`⚠️ Warning: Invalid ${resourceName} ID:`, id);
    return false;
  }
  return true;
};

/**
 * Create a safe response for invalid ID requests
 * @param {string} resourceName - Name of the resource
 * @returns {Object} - Safe response object
 */
export const createInvalidIdResponse = (resourceName = 'Resource') => {
  return {
    success: false,
    message: `Invalid ${resourceName} ID. Please check the data.`,
    data: null,
    error: 'INVALID_ID'
  };
};

